import { useAtom } from "jotai";

import { useGetCustomer } from "@/services/api";
import { isAnonymousUserAtom } from "@/utils/atoms";

// We can use this hook to get the customer data in the onboarding process
// where the customer might be anonymous and we cannot use the useGetCustomer hook.
export const useCustomerInOnboarding = () => {
  const [isAnonymousUser] = useAtom(isAnonymousUserAtom);
  const { data: customerData } = useGetCustomer(undefined, {
    query: {
      enabled: !isAnonymousUser,
    },
  });

  return customerData;
};
